export default "__VITE_ASSET__DYlpQ2iK__"